
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggGQimzCYvRtqCtgV0d4Qg2HXqBfNX5h4JUd4xh6FeKIMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexudO_45T7hGgsKB2CUhM9_sdujKT_451WQKq4P0RL9QFUWnQMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchcF9h05V8WlA6ugz8d1Xgg3XJjuvK4ubMxXWn96yuEf8Meta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexELV6oCiuAaoOEiPMg_FrOKaXWMibI2Zg2d_LodAgry4Meta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93V3Uxi7aLKNOV1wxYPUEXzVqhv4y1Ny0Rf_ldnOFb7DwMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexGuXn2sQaMj8Zmp__agg5Q_Jdd_45hERiH6W32IW_YdGt0Meta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93nVXIlYxMOjZtE_45CbBpcQGMgzRmSkk5GRY37gjoWkpEEMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexl96AqTBSeV7P2WDOXSHh5Uhzp554YqCudnPtMxe4kBMMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93gTQ_gNuIlhU4W_45nf_45jC_jCdzeb2HWex7PLBrpItiyuIMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_h710i56QN74esHap9fILPeYQWyy5OGBblXX7dNvphcMeta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexwTOFa0DWE9Zp3pFnPFx8lsnJepUw6kcdzxRijC_sJk4Meta } from "/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexGuXn2sQaMj8Zmp__agg5Q_Jdd_45hERiH6W32IW_YdGt0Meta || {},
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexl96AqTBSeV7P2WDOXSHh5Uhzp554YqCudnPtMxe4kBMMeta || {},
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_h710i56QN74esHap9fILPeYQWyy5OGBblXX7dNvphcMeta || {},
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexwTOFa0DWE9Zp3pFnPFx8lsnJepUw6kcdzxRijC_sJk4Meta || {},
    component: () => import("/codebuild/output/src102228454/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]